import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useIsMobile } from '../../../../hooks';
import { TParticiparteResponse } from '../../../../types';

import { StyledLoserTitle, StyledText } from '../style';

type TLoserCardProps = {
  gameResult: TParticiparteResponse['data'];
};

const LoserCard = ({ gameResult }: TLoserCardProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <Fragment>
      <StyledLoserTitle $isMobile={isMobile}>{t('youLose')}</StyledLoserTitle>
      <StyledText>{gameResult.message}</StyledText>
    </Fragment>
  );
};

export default LoserCard;
